export const SIGNUPSETUPDATA = {
    
  EnrollmentOptions: {
    newSetupFanList: {
      name: 'Set up your accounts',
      rowDisable: false,
      rowDisableCondition: {},
      rowDisableConditionInverse: false,
      columnDefinitions: [
        {
          caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
          enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
        }
      ]
    },
    revisedFanList: {
      name: 'Add accounts',
      rowDisable: true,
      rowDisableCondition: { field: 'addpEligibleStatus', value: undefined },
      rowDisableConditionInverse: false,
      columnDefinitions: [
        {
          caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 1, customTemplate: 'fanEligiblityStatus'
        },
        {
          caption: 'Existing devices', field: 'enroll', type: 'CUSTOMCONTENT', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 2, templateIndex: 0
        }
      ]
    },
    awaitingSignupFanList: {
      name: 'Add accounts',
      rowDisable: true,
      rowDisableCondition: { field: 'addpEligibleStatus', value: undefined },
      rowDisableConditionInverse: false,
      columnDefinitions: [
        {
          caption: 'Foundation account(s)', field: 'fanId', fanName: 'fanName', type: 'TEXT', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 1, customTemplate: 'fanEligiblityStatus'
        },
        {
          caption: 'Enroll existing devices?', field: 'enroll', type: 'CUSTOMCONTENT', sortDirection: 'Asc',
          enableSorting: false, enableFilter: false, cssClass: '', priority: 2, templateIndex: 0
        }
      ]
    }
  },
  ReviewPage: {
    columnDefinitions: [
      {
        caption: 'Foundation account', field: 'fanId', type: 'TEXT', sortDirection: 'Asc',
        enableSorting: true, enableFilter: true, cssClass: '', priority: 1, customTemplate: ''
      }
    ]
  }
  };
  